import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { IUserAuth } from '../data/IUserAuth';

@Injectable({ providedIn: 'root' })
export class AuthService {

  constructor(
    private router: Router
  ) {
  }

  public tokenExpired(): boolean {
    const expiry = parseInt(sessionStorage.getItem("expiration"));
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }

  public isAuthenticated(): boolean {
    const token = sessionStorage.getItem('token');
    if (!!!token) {
      return false;
    }

    return true;
  }

  public get user(): IUserAuth {
    return JSON.parse(sessionStorage.getItem('user'));
  }

  public get token(): string {
    return sessionStorage.getItem("token");
  }

  public logAuth(clientCode: string): void {
    this.router.navigate(['/auth/login', clientCode]);
    sessionStorage.clear();
  }
}
